const RefusalReasonEnum = {
  CATEGORY_FULLY_BOOKED: 'CATEGORY_FULLY_BOOKED',
  HOTEL_FULLY_BOOKED: 'HOTEL_FULLY_BOOKED',
  CONTRACTED_RATE_UNAVAILABLE: 'CONTRACTED_RATE_UNAVAILABLE',
  HOTEL_CLOSED: 'HOTEL_CLOSED',
  GUEST_POLICY_NOT_MET: 'GUEST_POLICY_NOT_MET',
  DUPLICATE_BOOKING: 'DUPLICATE_BOOKING',
  OTHER: 'OTHER',
};

export default RefusalReasonEnum;
